import styled from '@emotion/styled';
import React from 'react';
import { colors } from '@modernhealth/vital-foundation';
import { BodyTextMedium, BodyTextSmall, Link, pxToRem } from '@modernhealth/vital-components';
import { Trans, useTranslation } from 'react-i18next';

import { config } from 'src/modules/insuranceIntegration/config/config';
import { hexToRgba } from 'src/shared/helpers/hexToRgba';

export enum FooterType {
    INELIGIBLE_CONTACT_US_BOX = 'INELIGIBLE_CONTACT_US_BOX',
    INELIGIBLE_SMALL_TEXT = 'INELIGIBLE_SMALL_TEXT',
    CONTACT_US_BOX = 'CONTACT_US_BOX',
    SMALL_TEXT = 'SMALL_TEXT',
}
interface FooterGeneratorProps {
    footerType: FooterType;
}

const StyledLink = styled.a``;
const ContactUsBox = styled(BodyTextMedium)({
    width: '100%',
    backgroundColor: hexToRgba(colors.gray05, 0.5),
    borderRadius: 4,
    padding: `${pxToRem(10)} ${pxToRem(12)}`,
});

export const FooterGenerator: React.FC<FooterGeneratorProps> = ({ footerType }) => {
    const { t } = useTranslation();

    let footerMap: Map<FooterType, React.ReactNode> = new Map([
        [
            FooterType.INELIGIBLE_CONTACT_US_BOX,
            <ContactUsBox key={0} marginTop={20}>
                <Link>
                    <Trans
                        t={t}
                        ns="insuranceForm"
                        i18nKey="insurance_ineligible.questions"
                        components={{
                            contact: <StyledLink href={`mailto:${config.contactMail}`} />,
                        }}
                    />
                </Link>
            </ContactUsBox>,
        ],
        [
            FooterType.INELIGIBLE_SMALL_TEXT,
            <BodyTextSmall key={1} marginTop={20}>
                <Link>
                    <Trans
                        t={t}
                        ns="insuranceForm"
                        i18nKey="insurance_ineligible.alternative.questions"
                        components={{
                            contact: <StyledLink href={`mailto:${config.contactMail}`} />,
                        }}
                    />
                </Link>
            </BodyTextSmall>,
        ],
        [
            FooterType.CONTACT_US_BOX,
            <ContactUsBox key={2} marginTop={20}>
                <Link>
                    <Trans
                        t={t}
                        ns="insuranceForm"
                        i18nKey="insurance_approved.more_questions"
                        components={{
                            contact: <StyledLink href={`mailto:${config.contactMail}`} />,
                        }}
                    />
                </Link>
            </ContactUsBox>,
        ],
        [
            FooterType.SMALL_TEXT,
            <BodyTextSmall key={3} marginTop={10}>
                <Link>
                    <Trans
                        t={t}
                        ns="insuranceForm"
                        i18nKey="insurance_approved.pamm.more_questions"
                        components={{
                            contact: <StyledLink href={`mailto:${config.contactMail}`} />,
                        }}
                    />
                </Link>
            </BodyTextSmall>,
        ],
    ]);

    if (!footerMap.has(footerType)) {
        throw Error(`footerType of ${footerType} does not exist in footerMap`);
    }

    const footer: React.ReactNode = footerMap.get(footerType);
    return <>{footer}</>;
};
